export function normalizeBaseUrl(url: string): string {
  return url.endsWith("/") ? url.slice(0, -1) : url;
}

export * from "./slug";

/** Deterministic cross-app entry; no Explore record or service lookup is needed. */
export function buildExploreRunUrl(baseUrl: string, organizationId: number | string, runId: number | string): string {
  const base = new URL(baseUrl);
  if (!["https:", "http:"].includes(base.protocol) || base.username || base.password || base.search || base.hash) {
    throw new Error("Explore base URL must be a trusted HTTP(S) URL without credentials, query or fragment");
  }
  const ids = [organizationId, runId].map(String);
  if (ids.some((id) => !/^[1-9]\d*$/.test(id)))
    throw new Error("Explore requires positive numeric organization and run IDs");
  return `${base.href.replace(/\/$/, "")}/organizations/${ids[0]}/runs/${ids[1]}`;
}
